import { t } from "i18next";
import React from "react";

export function ErrorView(): React.ReactElement {
  // Render
  return (
    <div className="w-full h-full flex justify-center items-center text-center">
      {t("error")}.<br />
      Please try refreshing the page.
    </div>
  );
}
